/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {overtimeReportByTimecardForEmployee} from '../api'

 export const useQueryOvertimeReportByTimecardForEmployee = createReactQueryHook('overtimeReportByTimecardForEmployee', overtimeReportByTimecardForEmployee)
